// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8974) return "8974.c7f1cee4a68b5a991ebc.app-chunk.min.js?v=1756385242663";
	if (chunkId === 3470) return "3470.f6018c2d8b01a7ce106a.app-chunk.min.js?v=1756385242663";
	if (chunkId === 3602) return "notification.2c47326ab1fcfc57d2c5.app-chunk.min.js?v=1756385242663";
	if (chunkId === 2917) return "sticky-cart-new-4-0-13.d25259be6616ed8006e2.app-chunk.min.js?v=1756385242663";
	if (chunkId === 8075) return "wishlist-new-4-0-3.fcd8f56bf1c464e1ce15.app-chunk.min.js?v=1756385242663";
	if (chunkId === 4026) return "new-customer-pop.347f316cc4d2865001dd.app-chunk.min.js?v=1756385242663";
	if (chunkId === 9964) return "membership-packet.e9b90f9d26ebbfdecf12.app-chunk.min.js?v=1756385242664";
	// return url for filenames based on template
	return undefined;
};